module.exports = __webpack_public_path__ + "img/ss_ye-04.867046f6.jpg";